export default __webpack_public_path__ + "static/bed-bath-beyond-8-gg-8bdf969691a687e19c36a6350ae4f8e0.webp";